import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withAuthentication } from '~/hocs/withAuthentication';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';

const List = withAuthentication(({ user }) => {
  if (user.permissions.federation_admin) {
    return (
      <Fragment>
        <p>Genom att du är förbundsadministratör så har du rättigheter till alla distrikt.</p>
        <p>
          Därför bör du istället använda dig utav <Link to="/districts">distriktkatalogen</Link>, som du även kommer åt
          via huvudmenyn.
        </p>
      </Fragment>
    );
  }

  if (!user.permissions.districts_admin.length) {
    return <p>Du har inga distrikt som du administrerar för tillfället.</p>;
  }

  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Distrikt</Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {user.permissions.districts_admin.map(district => (
          <Table.Row key={district.id}>
            <Table.Col>
              <Link to={`/districts/${district.id}`}>{district.name}</Link>
            </Table.Col>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
});

export function Page() {
  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Mina distrikt" />
      </PageLayout.Header>

      <List />
    </Fragment>
  );
}
